var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acquisition",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9540",
    "data-name": "Group 9540",
    transform: "translate(1.935 1.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9529",
    "data-name": "Group 9529",
    transform: "translate(38.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11247",
    "data-name": "Path 11247",
    d: "M60.774,2V14.161L48.613,17.9,43,9.484,56.1,2Z",
    transform: "translate(-43 -2)",
    fill: "#b4dd7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9530",
    "data-name": "Group 9530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11248",
    "data-name": "Path 11248",
    d: "M14.863,7.454l.234.159L12.29,17.9,2,14.161V2H6.677Z",
    transform: "translate(-2 -2)",
    fill: "#ff826e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9531",
    "data-name": "Group 9531",
    transform: "translate(16.839 16.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11249",
    "data-name": "Path 11249",
    d: "M25.968,20.58a1.987,1.987,0,0,1,0,2.806l-2.582,2.582a1.984,1.984,0,0,1-2.806-2.806l2.582-2.582a1.987,1.987,0,0,1,2.806,0Z",
    transform: "translate(-20 -20)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9532",
    "data-name": "Group 9532",
    transform: "translate(20.581 5.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11250",
    "data-name": "Path 11250",
    d: "M41.774,9.871l5.613,8.419L42.71,21.1l-.168.075a2.034,2.034,0,0,0-.477-.655l-7.9-7.11a2.81,2.81,0,0,0-1.89-.73,2.855,2.855,0,0,0-1.459.4l-3.48,2.1a2.284,2.284,0,0,1-1.132.309,2.2,2.2,0,0,1-2.2-2.2V13.1a2.192,2.192,0,0,1,1.216-1.965l5.22-2.61A4.962,4.962,0,0,1,32.663,8a5.226,5.226,0,0,1,1.366.187L39.9,9.871Z",
    transform: "translate(-24 -8)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9533",
    "data-name": "Group 9533",
    transform: "translate(13.097 26.194)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-0.033 -0.129)",
    fill: "#ffc729"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9534",
    "data-name": "Group 9534",
    transform: "translate(10.29 3.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11251",
    "data-name": "Path 11251",
    d: "M34.479,29.387a2.528,2.528,0,0,1-1.59-.571l-1.413-1.188a2.038,2.038,0,0,0,.234-.935,1.984,1.984,0,0,0-3.386-1.4,1.984,1.984,0,0,0-2.806-2.806,1.984,1.984,0,0,0-2.806-2.806A1.984,1.984,0,0,0,19.9,16.87l-2.582,2.582a1.919,1.919,0,0,0-.533.982L13,18.161l2.806-10.29-.234-.159,6.586-1.459a10.512,10.512,0,0,1,5.51.253l4.285,1.366a4.962,4.962,0,0,0-2.226.524L24.506,11a2.192,2.192,0,0,0-1.216,1.965v.187a2.2,2.2,0,0,0,2.2,2.2,2.284,2.284,0,0,0,1.132-.309l3.48-2.1a2.855,2.855,0,0,1,1.459-.4,2.81,2.81,0,0,1,1.89.73l7.9,7.11a2.034,2.034,0,0,1,.477.655,1.883,1.883,0,0,1,.168.786,1.944,1.944,0,0,1-1.946,1.946H39.9a1.972,1.972,0,0,1-1.244-.449L38.5,23.2a1.909,1.909,0,0,1-1.216,3.377h-.206a1.946,1.946,0,0,1-1.225-.44l-.159-.131a1.9,1.9,0,0,1,.131,2.816,1.731,1.731,0,0,1-.477.346,1.843,1.843,0,0,1-.87.215Z",
    transform: "translate(-13 -6)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9535",
    "data-name": "Group 9535",
    transform: "translate(22.452 22.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11252",
    "data-name": "Path 11252",
    d: "M32.315,28.919a2.089,2.089,0,0,1-.346.468L29.63,31.725l-.243.243a1.983,1.983,0,0,1-3.368-1.151A2.293,2.293,0,0,1,26,30.565a1.982,1.982,0,0,1,.58-1.4l2.582-2.582a1.983,1.983,0,0,1,3.386,1.4,2.038,2.038,0,0,1-.234.935Z",
    transform: "translate(-26 -26)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9536",
    "data-name": "Group 9536",
    transform: "translate(14.032 14.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11253",
    "data-name": "Path 11253",
    d: "M22.968,17.58a1.987,1.987,0,0,1,0,2.806l-2.582,2.582A1.984,1.984,0,0,1,17,21.565a2.073,2.073,0,0,1,.047-.421,1.919,1.919,0,0,1,.533-.982l2.582-2.582a1.987,1.987,0,0,1,2.806,0Z",
    transform: "translate(-17 -17)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9537",
    "data-name": "Group 9537",
    transform: "translate(19.645 19.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11254",
    "data-name": "Path 11254",
    d: "M28.968,23.58a1.987,1.987,0,0,1,0,2.806l-2.582,2.582a1.984,1.984,0,0,1-2.806-2.806l2.582-2.582a1.987,1.987,0,0,1,2.806,0Z",
    transform: "translate(-23 -23)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9538",
    "data-name": "Group 9538",
    transform: "translate(26.081 25.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11255",
    "data-name": "Path 11255",
    d: "M33.977,30.308a1.909,1.909,0,0,1-1.216,3.377h-.178a1.893,1.893,0,0,1-1.263-.477L29.88,31.926l2.339-2.339a2.089,2.089,0,0,0,.346-.468Z",
    transform: "translate(-29.88 -29.12)",
    fill: "#f0d0b4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9539",
    "data-name": "Group 9539",
    transform: "translate(16.839 29.935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0.227 0.129)",
    fill: "#fcd770"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9541",
    "data-name": "Group 9541",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11256",
    "data-name": "Path 11256",
    d: "M53.138,1l-13.1,7.484H38.55L32.8,6.84a5.846,5.846,0,0,0-1.389-.2L27.177,5.287a11.541,11.541,0,0,0-5.995-.272l-6.2,1.378L6.9,1H1V14.752l10.822,3.936,3.22,1.932a2.912,2.912,0,0,0,2.808,2.822,2.912,2.912,0,0,0,2.806,2.806,2.909,2.909,0,0,0,2.108,2.69,15.9,15.9,0,1,0,13.45-.476,2.8,2.8,0,0,0,.33-1.272,2.845,2.845,0,0,0,2.806-2.809,2.878,2.878,0,0,0,2.81-2.871,2.751,2.751,0,0,0-.034-.315l4.16-2.5L59,14.788V1ZM2.871,13.442V2.871H6.329l7.622,5.082-2.362,8.66ZM16.9,20.532a1.045,1.045,0,0,1,.307-.742l2.58-2.58a1.049,1.049,0,0,1,1.484,1.484l-2.58,2.58a1.049,1.049,0,0,1-1.791-.742Zm2.806,2.806a1.045,1.045,0,0,1,.307-.742l2.58-2.58A1.049,1.049,0,0,1,24.08,21.5L21.5,24.08a1.049,1.049,0,0,1-1.791-.742ZM22.823,25.4l2.58-2.58a1.049,1.049,0,0,1,1.484,1.484l-2.58,2.58A1.049,1.049,0,0,1,22.823,25.4Zm6.128-.08a1.049,1.049,0,0,1,.742,1.791l-2.58,2.58a1.049,1.049,0,0,1-1.484-1.484l2.58-2.58A1.045,1.045,0,0,1,28.951,25.323Zm1.872,3.307.7.581a.976.976,0,0,1-.625,1.725h-.173a.977.977,0,0,1-.645-.244l-.7-.617ZM30,32.806A10.29,10.29,0,1,1,19.71,43.1,10.3,10.3,0,0,1,30,32.806ZM44.032,43.1A14.032,14.032,0,1,1,23.887,30.464a2.916,2.916,0,0,0,1.739,1.3,12.157,12.157,0,1,0,7.706-.352A2.815,2.815,0,0,0,33.738,30a2.8,2.8,0,0,0,.852-.152A13.939,13.939,0,0,1,44.032,43.1ZM39.284,22.516h-.162a1,1,0,0,1-.644-.233l-.148-.123-4.925-4.1-1.2,1.437,4.925,4.1a.976.976,0,0,1-.625,1.726h-.2a.977.977,0,0,1-.625-.226l-.156-.13-4.925-4.1L29.4,22.3l4.925,4.1a.976.976,0,0,1-.625,1.726,1.538,1.538,0,0,1-.984-.356l-.921-.767a2.977,2.977,0,0,0,.074-.634,2.917,2.917,0,0,0-2.817-2.909,2.912,2.912,0,0,0-2.806-2.806,2.912,2.912,0,0,0-2.806-2.806,2.914,2.914,0,0,0-4.974-1.962l-2.58,2.58a2.842,2.842,0,0,0-.263.32L13.315,17.4l2.531-9.284,5.741-1.276a9.672,9.672,0,0,1,5.019.228l1.377.441L23.312,9.846a3.116,3.116,0,0,0-1.732,2.8v.186a3.133,3.133,0,0,0,4.746,2.686l3.483-2.09a1.934,1.934,0,0,1,2.243.216l7.9,7.114a1.007,1.007,0,0,1-.674,1.755Zm1.925-3.144-7.9-7.114a3.843,3.843,0,0,0-4.459-.43l-3.483,2.09a1.262,1.262,0,0,1-1.911-1.082v-.186a1.255,1.255,0,0,1,.7-1.129L29.369,8.91a4.084,4.084,0,0,1,2.916-.271l5.879,1.679,1.622.027,4.8,7.195L41.322,19.5c-.04-.038-.071-.086-.113-.123Zm15.92-5.967L46.294,16.74l-4.67-7L53.636,2.871h3.493Z",
    transform: "translate(-1 -1)",
    fill: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11257",
    "data-name": "Path 11257",
    d: "M30.742,51.968v1.871h1.871V51.968a3.742,3.742,0,0,0,0-7.484H30.742a1.871,1.871,0,0,1,0-3.742h1.871a1.873,1.873,0,0,1,1.871,1.871h1.871a3.746,3.746,0,0,0-3.742-3.742V37H30.742v1.871a3.742,3.742,0,0,0,0,7.484h1.871a1.871,1.871,0,0,1,0,3.742H30.742a1.873,1.873,0,0,1-1.871-1.871V47.29H27v.935A3.746,3.746,0,0,0,30.742,51.968Z",
    transform: "translate(-2.677 -3.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11258",
    "data-name": "Path 11258",
    d: "M48.2,36.815l1.5,1.123L53.626,32.7V52.344H55.5V32.7l3.929,5.239,1.5-1.123-6.361-8.482Z",
    transform: "translate(-4.045 -2.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11259",
    "data-name": "Path 11259",
    d: "M54,56h1.871v1.871H54Z",
    transform: "translate(-4.419 -4.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11260",
    "data-name": "Path 11260",
    d: "M14.923,36.815,8.561,28.333,2.2,36.815l1.5,1.123L7.626,32.7V52.344H9.5V32.7l3.929,5.239Z",
    transform: "translate(-1.077 -2.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11261",
    "data-name": "Path 11261",
    d: "M8,56H9.871v1.871H8Z",
    transform: "translate(-1.452 -4.548)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales-icon.88768e07d1db1e0f2dfead15b9d64ae1.svg";
export { ForwardRef as ReactComponent };